export function routes($stateProvider) {
  $stateProvider
    .state('app.servico', {
      url: '/servico',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.servico.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Serviços',
      template: require('./directory/directory.view.html'),
      controller: 'ServicoListController',
      controllerAs: 'vm',
      role: 'servicoRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "asc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.servico.details', {
      url: '/{id}',
      title: 'Prestação de Serviço',
      controller: 'ServicoDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'servicoRead'
    })
    .state('app.servico.new', {
      url: '/novo',
      title: 'Nova Prestação de Serviço',
      template: require('./new/new.view.html'),
      controller: 'ServicoCreateServicoController',
      controllerAs: 'vm',
      role: 'servicoCreate'
    })
    .state('app.servico.new.1', {
      template: require('./new/servico.1.form.html')
    })
    .state('app.servico.new.2', {
      template: require('./new/servico.2.form.html')
    })
    .state('app.servico.new.3', {
      template: require('./new/servico.3.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
